import { useMemo } from 'react';
// FIX: the currently publised version of Nivo doesn't expose legends to custom layers
// this will be fixed in the next publised version
// V0.79.1: https://github.com/plouc/nivo/blob/v0.79.1/packages/bar/src/Bar.tsx#L358
// master:  https://github.com/plouc/nivo/blob/master/packages/bar/src/Bar.tsx#L373
export function useCustomBarLegend(param) {
    var data = param.data, layerData = param.layerData, hiddenSeries = param.hiddenSeries, answersById = param.answersById;
    var hiddenSeriesSet = useMemo(function() {
        return new Set(hiddenSeries);
    }, [
        hiddenSeries
    ]);
    var legendsData = useMemo(function() {
        var computedLegendsData = [];
        for(var i = 0; i < layerData.length; i += data.length){
            var _answersById_id;
            var layerValue = layerData[i];
            var id = layerValue.key.split('.')[0];
            computedLegendsData.push({
                color: hiddenSeriesSet.has(id) ? 'gray.200' : layerValue.color,
                label: (_answersById_id = answersById[id]) === null || _answersById_id === void 0 ? void 0 : _answersById_id.option_text,
                id: id,
                textColor: hiddenSeriesSet.has(id) ? 'gray.300' : 'gray.700'
            });
        }
        return computedLegendsData;
    }, [
        answersById,
        hiddenSeriesSet,
        layerData,
        data
    ]);
    return legendsData;
}
